// components/Footer.jsx
import React from "react";
import "./Footer.css";
import FacebookRoundedIcon from "@mui/icons-material/FacebookRounded";
import InstagramIcon from "@mui/icons-material/Instagram";
import TwitterIcon from "@mui/icons-material/Twitter";
import { Link } from "react-router-dom";

function Footer() {
   const navItems = [
    { label: "Home", target: "hero" },
     { label: "Features", target: "features" },
  { label: "Who its for", target: "who" },
   { label: "Community", target: "community" },

    { label: "Who We Are", target: "about" },
   { label: "Contact", target: "contact" },
  
  
    
  ];

  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <footer className="tawaf-footer">
      <div className="tawaf-footer-inner">
        <div className="tawaf-footer-top">

          {/* BRAND */}
          <div className="tawaf-footer-brand">
            <h3>TAWAF</h3>
            <p>
            Tawaf is your trusted digital companion for Hajj & Umrah. <br/>keeping you safe, confident, and focused on worship
            </p>
          </div>

          {/* NEW – CLEAN NAV SECTION */}
          <div className="tawaf-footer-cols">

            {/* NAVIGATION */}
            <div className="tawaf-footer-col">
              <h4>Navigation</h4>
              {navItems.map((item) => (
                <button
                  key={item.label}
                  className="tawaf-footer-nav-btn"
                  onClick={() => scrollToSection(item.target)}
                >
                  {item.label}
                </button>
              ))}
            </div>

            {/* LEGAL */}
            <div className="tawaf-footer-col">
              <h4>Legal</h4>

              <Link to="/privacy-policy" className="tawaf-footer-link-btn">
                Privacy Policy
              </Link>

              <Link to="/terms-of-service" className="tawaf-footer-link-btn">
                Terms of Service
              </Link>

              <Link
                to="/compliance-and-security"
                className="tawaf-footer-link-btn"
              >
                Compliance &amp; Security
              </Link>
            </div>

            {/* SOCIAL */}
            <div className="tawaf-footer-col">
              <h4>Connect</h4>

              <div className="tawaf-footer-social">
                <a
                  aria-label="Facebook"
                  href="https://www.facebook.com/profile.php?id=61583006320861"
                  target="_blank"
                  rel="noreferrer"
                >
                  <FacebookRoundedIcon fontSize="small" />
                </a>

                <a
                  aria-label="Instagram"
                  href="https://www.instagram.com/tawaf_ai/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <InstagramIcon fontSize="small" />
                </a>

                <a
                  aria-label="X (Twitter)"
                  href="https://x.com/Tawaf_AI"
                  target="_blank"
                  rel="noreferrer"
                >
                  <TwitterIcon fontSize="small" />
                </a>
              </div>
            </div>

          </div>
        </div>

        {/* BOTTOM BAR */}
        <div className="tawaf-footer-bottom">
          <span>© 2025 Tawaf — All Rights Reserved</span>
          <span className="tawaf-footer-bottom-right">
            <Link to="/compliance-and-security">Safety</Link> •{" "}
            <Link to="/privacy-policy">Privacy</Link> •{" "}
            <Link to="/terms-of-service">Respect</Link>
          </span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
